import { createAsyncThunk, current } from '@reduxjs/toolkit';
import axios from 'axios';

export const initStateUpdateDamping = {
  updateDamping: { data: null, loading: false, error: null },
};

export const updateDamping = createAsyncThunk('user/updateDamping', async (data, { rejectWithValue, fulfillWithValue }) => {
  const token = localStorage?.getItem('token');
  if (!token) rejectWithValue({ error: 'PROBLEM_WITH_TOKEN' });
  return await axios
    .put(`${process.env.REACT_APP_SERVER_API}/kaspi-products/damping/`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: '*/*',
        'Content-Type': 'application/json',
      },
    })
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerUpdateDamping = {
  [updateDamping.pending]: (state) => {
    state.updateDamping.loading = true;
  },
  [updateDamping.fulfilled]: (state, action) => {
    state.updateDamping.loading = false;
    state.updateDamping.data = action.payload;
    state.updateDamping.error = null;
  },
  [updateDamping.rejected]: (state, action) => {
    state.updateDamping.loading = false;
    state.updateDamping.error = action.payload;
  },
};
